(() => {
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const selector = [
    '.wr-page-shell h1',
    '.wr-page-shell h2',
    '.wr-page-shell .wr-section-head > div > p:first-child',
    '.wr-page-shell .wr-collections-editorial > p:first-child',
    '.wr-page-shell .wr-collections-menu-panel__head > p:first-child',
    '.wr-page-shell .wr-collection-page__eyebrow',
    '.wr-page-shell .wr-not-found__eyebrow',
    '.wr-page-shell .wr-cart-page__summary-eyebrow'
  ].join(',');

  const excluded = [
    '.wr-statement',
    '.wr-about-manifesto',
    '.wr-about-page',
    '.wr-product-card',
    '.wr-collection-story-card',
    '.wr-collage',
    '.wr-mira-image-stage',
    '.wr-mira-media-hero',
    '.wr-reel-3d',
    '.wr-home-ribbon',
    '.wr-overlay',
    '.wr-drawer',
    'header',
    'footer',
    '[hidden]',
    '[aria-hidden="true"]'
  ].join(',');

  const registered = new WeakSet();
  let observer;

  const reveal = (element) => {
    if (element.classList.contains('is-light-visible')) return;
    element.classList.add('is-light-visible');
    observer?.unobserve(element);
  };

  const register = (root = document) => {
    const elements = [];
    if (root.nodeType === 1 && root.matches?.(selector)) elements.push(root);
    elements.push(...root.querySelectorAll(selector));

    elements.forEach((element, index) => {
      if (registered.has(element) || element.closest(excluded)) return;
      if (!/[\p{L}\p{N}]/u.test(element.textContent || '')) return;

      registered.add(element);
      element.classList.add('wr-light-reveal');
      element.style.setProperty('--wr-light-delay', `${(index % 3) * 55}ms`);

      if (reducedMotion || !observer) reveal(element);
      else observer.observe(element);
    });
  };

  const start = () => {
    if (!reducedMotion && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)
          .forEach((entry) => reveal(entry.target));
      }, { rootMargin: '0px 0px -10% 0px', threshold: .08 });
    }

    register(document);
    document.documentElement.classList.add('wr-light-reveal-ready');
  };

  requestAnimationFrame(start);
  document.addEventListener('shopify:section:load', (event) => register(event.target));
})();
